export const iconFontAwesomeToggleCircle = (
	<i className="fa-solid fa-circle"></i>
);
